import type { StripeAddressElementOptions } from "@stripe/stripe-js";
import { useMemo } from "react";

export const useAddressElementDisplay = () =>
  useMemo<StripeAddressElementOptions["display"]>(
    () => ({
      // We always display the full name. No support for organizations yet.
      name: "full",
    }),
    [],
  );
